<template>
  <DashboardHeader title="Previous Years">
    <v-layout>
      <v-flex xs12 md3>
        <v-card class="mx-4 mt-4" shaped elevation="12" max-width="344" outlined>
          <h3 class="mx-5 mt-4">Previous Years</h3>
        </v-card>

        <v-card class="mx-4 mt-4" shaped elevation="12" max-width="344" outlined>
          <v-list-item three-line>
            <v-select v-model="selectedSubject" :items="subjects" label="Select Subject"></v-select>
          </v-list-item>
        </v-card>

        <v-card
          class="mx-4 mt-4"
          shaped
          elevation="12"
          max-width="344"
          outlined
          v-if="selectedSubject"
        >
          <v-list-item three-line>
            <v-select v-model="selectedYear" :items="years" label="Select Year"></v-select>
          </v-list-item>
        </v-card>

        <v-card
          class="mx-4 mt-4"
          shaped
          elevation="12"
          max-width="344"
          outlined
          v-if="selectedYear"
        >
          <v-list-item three-line>
            <v-select v-model="selectedMonth" :items="months" label="Select Month"></v-select>
          </v-list-item>
        </v-card>

        <v-card
          class="mx-4 mt-4"
          shaped
          elevation="12"
          max-width="344"
          outlined
          v-if="selectedMonth"
        >
          <v-list-item three-line>
            <v-select v-model="selectedPaper" :items="papers" label="Select Paper"></v-select>
          </v-list-item>
        </v-card>

        <v-card
          class="mx-4 mt-4"
          shaped
          elevation="12"
          max-width="344"
          outlined
          v-if="selectedPaper"
        >
          <v-list-item three-line>
            <v-select
              @change="retrieveSelection()"
              v-model="selectedCat"
              :items="categories"
              label="Select Category"
            ></v-select>
          </v-list-item>
        </v-card>

        <v-card
          class="mx-4 mt-4 mb-2"
          shaped
          elevation="12"
          max-width="344"
          outlined
          v-if="getCurrentUser.alevel >= 20"
        >
          <v-file-input
            class="mb-2"
            show-size
            counter
            label="Click Here To Upload PDF"
            @change="getPDF()"
          ></v-file-input>
          <v-btn class="mx-6 my-2" rounded :color="getThemeColor" dark @click="uploadPDF()">Upload</v-btn>
        </v-card>
      </v-flex>
      <v-flex xs12 md8>
        <h5 v-if="iframeSource == null || iframeSource == undefined">
          No Files Exist For The Selection
          <br />
        </h5>

        <v-snackbar v-model="snackBar" dark :color="getThemeColor">
          {{ snackText }}
          <v-btn color="pink" text @click="snackBar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="mx-4 mt-4 mb-2" shaped elevation="12" outlined>
          <iframe :src="iframeSource" frameborder="0" width="100%" height="700"></iframe>
        </v-card>
      </v-flex>
    </v-layout>
  </DashboardHeader>
</template>

<script>
import DashboardHeader from "../../components/DashboardHeader.vue";
import axios from "../../plugins/axios";
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["getAccessToken", "getCurrentUser", "getThemeColor"]),
  components: {
    DashboardHeader
  },
  mounted() {
    axios.getData("/auth/all-subjects", this.getAccessToken).then(response => {
      this.subjects = [];
      response.forEach((subject, index) => {
        this.subjects.push({ text: subject.name, value: subject.subject_id });
      });
    });
  },
  data() {
    return {
      snackBar: false,
      snackText: "",
      subjects: [],
      iframeSource: "",
      selectedSubject: null,
      selectedCat: null,
      selectedYear: null,
      selectedPaper: null,
      selectedPDF: null,
      selectedMonth: null,
      pdfs: [],
      years: [
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019
      ],
      papers: [
        { text: "Paper 1", value: 1 },
        { text: "Paper 2", value: 2 },
        { text: "Paper 3", value: 3 },
        { text: "Other", value: "o" }
      ],
      categories: [
        { text: "Question Paper", value: "q" },
        { text: "Memorandum", value: "m" },
        { text: "Notes", value: "n" }
      ],
      months: [
        { text: "Feb/March", value: "fm" },
        { text: "May/June", value: "mj" },
        { text: "October/November", value: "on" }
      ],
      pdf: "",
      filename: ""
    };
  },
  methods: {
    retrieveSelection() {
      axios
        .postDataWithToken(
          "/auth/get-previous-year-selections-file",
          {
            subjectId: this.selectedSubject,
            year: this.selectedYear,
            month: this.selectedMonth,
            paper: this.selectedPaper,
            category: this.selectedCat
          },
          this.getAccessToken
        )
        .then(response => {
          this.iframeSource =
            "https://api.baronitsolution.com/pdfs/previous_years/" + response;
        });
    },
    getPDF() {
      const file = event.target.files[0];
      this.filename = file.name;

      const fileReader = new FileReader();

      fileReader.addEventListener("load", () => {
        this.pdf = fileReader.result;
      });

      fileReader.readAsDataURL(file);
    },
    getSeletedPDF() {
      this.iframeSource =
        "https://projectexecutionprocess.co.za" + this.selectedPDF;
    },
    uploadPDF() {
      axios
        .postData("/auth/upload-pdfs", {
          pdf: this.pdf,
          name: this.filename,
          projectId: this.projectsData.id
        })
        .then(response => {
          this.snackBar = true;
          this.snackText = "PDF File Successfuly Uploaded";
          axios
            .postData("/auth/get-all-pdfs", {
              projectId: this.projectsData.id
            })
            .then(response2 => {
              this.pdfs = response2;
            });
        });
    },
    getSeletedSubject() {
      axios
        .postData("/auth/py-get-selected-subject", {
          projectId: this.selectedSubject
        })
        .then(response => {
          axios
            .postData("/auth/get-all-pdfs", {
              projectId: this.selectedProject
            })
            .then(response => (this.pdfs = response));
        });
    }
  }
};
</script>

<style>
</style>